(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ferwarm-offer-box"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Même compte à rebours que le bouton noir du premier écran : même mémoire (fw-countdown-end), donc la même heure partout. */
    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function init() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-fw-box-timer]'), function (el) {
        if (el.getAttribute('data-fw-ready') === 'true') return;
        el.setAttribute('data-fw-ready', 'true');

        var total = parseInt(el.getAttribute('data-seconds'), 10) || 0;
        if (total <= 0) return;

        var key = 'fw-countdown-end';
        var end = 0;
        var now = Date.now();
        try { end = parseInt(window.localStorage.getItem(key), 10) || 0; } catch (e) {}
        if (!end || end <= now || end - now > total * 1000) {
          end = now + total * 1000;
          try { window.localStorage.setItem(key, String(end)); } catch (e) {}
        }

        var h = el.querySelector('[data-fw-h]');
        var m = el.querySelector('[data-fw-m]');
        var s = el.querySelector('[data-fw-s]');

        function tick() {
          var left = Math.round((end - Date.now()) / 1000);
          if (left <= 0) {
            end = Date.now() + total * 1000;
            try { window.localStorage.setItem(key, String(end)); } catch (e) {}
            left = total;
          }
          if (h) h.textContent = pad(Math.floor(left / 3600));
          if (m) m.textContent = pad(Math.floor((left % 3600) / 60));
          if (s) s.textContent = pad(left % 60);
        }

        tick();
        window.setInterval(tick, 1000);
      });
    }

    init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
